import React from 'react';

import { Box, Typography } from '@mui/material';

import { SelectableCode } from '../../../../common/types/Codes';

type CodeExtraInfoProps = {
  code: SelectableCode;
};

export const CodeExtraInfo: React.FC<CodeExtraInfoProps> = ({ code }) => {
  return (
    <Box sx={{ mt: '24px' }} className='row'>
      <Box className='row'>
        {code.work_rvu && (
          <Box className='row' sx={{ marginRight: '35px' }}>
            <Typography
              sx={{ marginRight: '8px' }}
              fontFamily={'SFProDisplay-Bold'}
            >
              {code.work_rvu}
            </Typography>
            <Typography
              color='text.secondary'
              fontFamily={'SFProDisplay-Regular'}
            >
              Work RVU
            </Typography>
          </Box>
        )}
        {code.facility_total && (
          <Box className='row'>
            <Typography
              sx={{ marginRight: '8px' }}
              fontFamily={'SFProDisplay-Bold'}
            >
              {code.facility_total}
            </Typography>
            <Typography
              color='text.secondary'
              fontFamily={'SFProDisplay-Regular'}
            >
              Total RVU
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
